<template>
<m-pageframe
    title="Search Conversations"
>
<v-container
    v-if="data != null"
>

    <h2>{{title}}</h2>

    <v-data-table
        :headers="headers"
        :items="data.conversations"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        style="margin-top: 15px; margin-bottom: 15px;"
    >
    
        <template v-slot:item.first_message_time="{ item }">
            {{$rc.pretty(item.first_message_time,'date')}}
        </template>

        <template v-slot:item.last_message_time="{ item }">
            {{$rc.pretty(item.last_message_time,'date')}}
        </template>

        <template v-slot:item.action="{ item }">
            <a
                v-on:click="onClickViewConversation(item)" 
            >
                View...
            </a>
        </template>
    
    </v-data-table>

    <div
        v-for="(number, index) in data.customer.customer_phone_numbers"
        :key="index"
        style="margin-bottom: 15px; text-decoration: underline;"
    >
        <a
            v-on:click="onClickPhoneNumber(number)"
        >
            Text {{data.customer.full_name}} on {{$rc.pretty(number,'endpoint')}}
        </a>
    </div>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            data: null,

            headers: [
                { text: 'With', value: 'label'},
                { text: 'First Message', value: 'first_message_time'},
                { text: 'Last Message', value: 'last_message_time'},
                { text: '# of Messages', value: 'message_count'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET: /api/v1/integrations/crm/customer-conversations/:organization_id/:content_type/:customer_id',
            
                {
                    'organization_id': this.$route.params.organization_id,
                    'content_type': this.$route.params.content_type,
                    'customer_id': this.$route.params.customer_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.data = data;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickViewConversation(converation)
        {
            this.$router.push({
                'name': 'home-routed',
                'params' : converation.url_params
            });
        },

        onClickPhoneNumber(number)
        {
            let params = {
                'customer_id' : this.$route.params.customer_id,
                'organization_id' : this.$route.params.organization_id,
                'content_type' : this.$route.params.content_type,
                'customer_endpoint' : number
            };

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/integrations/crm/customers/start-conversation',
            
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$router.push({
                        'name': 'home-routed',
                        'params' : data,
                        }).catch(e=>{}); // swallow any exception
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to start conversation');
                },
            );
        },
    },

    computed: {
        title() {
            if ( this.data == null ) return 'Conversations in RedChirp';

            let name = this.data.customer.full_name;

            return name+' Conversations in RedChirp';
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
